import { render, staticRenderFns } from "./wechatBind.vue?vue&type=template&id=6be14a22&scoped=true&"
import script from "./wechatBind.vue?vue&type=script&lang=js&"
export * from "./wechatBind.vue?vue&type=script&lang=js&"
import style0 from "./wechatBind.vue?vue&type=style&index=0&id=6be14a22&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be14a22",
  null
  
)

export default component.exports